import React from "react";
import { Box } from "@mui/material";

const AnkleNFootPage = () => {
  return (
    <Box
      sx={{
        padding: 10,
      }}
    >
      {"WIP: Angle & Foot"}
    </Box>
  );
};

export default AnkleNFootPage;
